<!-- eslint-disable sonarjs/no-duplicate-string -->
<template>
  <Sect id="SectionApvaIntro">
    <Wrap class="lg">
      <h2>Įsigykite elektrinės dalį iki 35% pigiau su APVA parama</h2>
      <h3 class="apvaHeader">
        2025 m. parama pasibaigė.
      </h3>
      <Row class="points">
        <Column v-for="(card, index) in cards" :key="index" :md="4">
          <Card class="apvaPoint">
            <Icon :name="card.icon" />
            <h3>{{ card.label }}</h3>
          </Card>
        </Column>
      </Row>
      <div class="contactContainer">
        <Route class="Btn arrow inv contact" to="Contact">
          Nemokama konsultacija
        </Route>
      </div>
    </Wrap>
    <Wrap class="md">
      <div class="textContainer">
        <p>
          Saulės elektrinių finansavimas ir parama Lietuvos gyventojams – pagalba žmonėms, norintiems prisidėti prie alternatyvios energijos naudojimo ir aplinkosaugos. Pasinaudokite patogiomis valstybės finansavimo galimybėmis ir atsinaujinančią energiją naudokite pigiau. Paramą inicijuoja APVA – LR Aplinkos ministerijos Aplinkos projektų valdymo agentūra.
        </p>
      </div>
    </Wrap>
  </Sect>
</template>

<script>
import Card from 'components/globals/Card'
import { getters } from 'views/utils'

export default {
  components: { Card },
  computed: {
    apvaText() {
      const currentApvaStage = this.getSnippetValue('apvaStage')

      return currentApvaStage || 'Nauja APVA parama - jau greitai'
    },
    cards() {
      return [
        {
          icon: 'coin',
          label: 'Suteikiama parama iki 3 230 Eur',
        },
        {
          icon: 'calculator',
          label: 'Gavus paramą, investicija atsipirks per 4-5 metus',
        },
        {
          icon: 'calendar-clock',
          label: this.apvaText,
        },
      ]
    },
    ...getters('getSnippetValue'),
  },
}
</script>

<style lang="scss">
#SectionApvaIntro {
  h2 {
    @include dotAbove(1.5rem);
    margin: 3rem 0;
  }

  .apvaHeader {
    font-size: $h25;
  }
  // display: flex;
  // padding-left: 2rem;
  // position: relative;

  .points {
    gap: 1rem;
    margin: 4rem 0;
    @include md {
      gap: unset;
    }
  }

  .contactContainer {
    display: flex;
    justify-content: center;

    .Btn.contact {
      max-width: 20rem;
      text-align: center;
    }
  }

  .textContainer {
    margin-bottom: 3rem;
    margin-top: 3rem;

    > p {
      margin-bottom: 2rem;
    }
  }

  .apvaPoint {
    background: $white;
    border-radius: $radius 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    padding: 3rem;
    width: 100%;
    @include md {
      margin-bottom: 0;
    }

    h3 {
      font-weight: $bold;
    }

    .Icon {
      color: $blue;
      font-size: 6rem;
    }

  }
}
</style>
